import { cx } from 'utils/cx'
import { ButtonBase } from '../Base/ButtonBase'
import { BUTTON_VARIANT } from '../Button.types'

import styles from '../Primary/ButtonPrimary.module.css'

interface PrimaryWithIconProps extends React.ComponentProps<'button'> {
	readonly fullWidth?: boolean
	readonly isLoading?: boolean
	readonly icon: React.ReactNode
	readonly variant?: BUTTON_VARIANT
}

export function ButtonPrimaryWithIcon(
	props: PrimaryWithIconProps
): React.ReactNode {
	const {
		isLoading = false,
		variant = BUTTON_VARIANT.DEFAULT,
		className,
		disabled,
		children,
		icon,
		fullWidth,
		...rest
	} = props

	const disabledButton = disabled || isLoading

	return (
		<ButtonBase
			{...rest}
			fullWidth={fullWidth}
			className={cx(className, styles[variant])}
			disabled={disabledButton}
		>
			{icon}
			<span>{children}</span>
		</ButtonBase>
	)
}
